import { render } from "./JFfail.vue?vue&type=template&id=09c3c122&scoped=true"
import script from "./JFfail.vue?vue&type=script&lang=js"
export * from "./JFfail.vue?vue&type=script&lang=js"

import "./JFfail.vue?vue&type=style&index=0&id=09c3c122&lang=scss&scoped=true"
import "./JFfail.vue?vue&type=style&index=1&id=09c3c122&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c3c122"]])

export default __exports__